<template>
    <div>
        <v-card class="rounded-lg" elevation="2">
            <v-tabs v-model="tab" fixed-tabs background-color="#41916b" dark>
                <v-tabs-slider color="#b1e3cc"></v-tabs-slider>
                <v-tab>{{resource.id ? $t('buttons.update_patient') : $t('buttons.new_patient')}}</v-tab>
                <v-tab-item>
                    <v-card-text>
                       <PacienteForm :activeSearch="activeSearch"/>
                    </v-card-text>
                </v-tab-item>
            </v-tabs>
        </v-card>
        
        <v-snackbar absolute background-color="white" color="#236947" v-model="snackbar">
            {{ message }}
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                Fechar
                </v-btn>
            </template>
        </v-snackbar>

        <v-snackbar absolute background-color="white" color="#9e212e" v-model="snackbarLimit">
            {{ message }}
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbarLimit = false">
                Fechar
                </v-btn>
            </template>
        </v-snackbar>

        <v-snackbar absolute background-color="white" color="#9e212e" v-model="displayError.display">
          {{  displayError.message  }}
          <template v-slot:action="{ attrs }">
              <v-btn color="white" text v-bind="attrs" @click="displayError.display = false">
              Fechar
              </v-btn>
          </template>
        </v-snackbar>
    </div>
</template>
  
<script> 
import { mapGetters } from "vuex";
import PacienteForm from "./PacienteForm-comp.vue";
export default {
    data() {
        return {
            displayError: {
                display: false,
                message: [],
            },
            message: "",
            snackbar: false,
            snackbarLimit: false,
            tab: null,
            activeSearch: {}
        };
    },

    components: {
      PacienteForm
    },

    computed:{
        ...mapGetters({
            resource: "getPatientData"
        }),
    },
};
</script>
  
<style scoped>
.v-btn:not(.v-btn--round).v-size--default {
    height: 40px !important;
}
</style>
  